import * as types from './mutation-types';

export const toggleModalDeleteServiceTributes = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_DELETE_SERVICE_TRIBUTES);
};

export const setModalDeleteServiceTributesIds = async (context, payload) => {
  const tributesIds = payload.filter((e) => e.id).map((e) => e.id);
  context.commit(types.SET_MODAL_DELETE_SERVICE_TRIBUTES_IDS, tributesIds);
};
